import { z } from "zod";
import { expectedVersion, id, pageInput } from "./common";
import { longText, safeText } from "./text";
import { VISIBILITIES } from "./visibility";

const unique = (items: readonly string[]) => new Set(items).size === items.length;
const linkedIds = z.array(id).max(20).refine(unique, "Each record only once");

const ideaFields = z.object({
  title: safeText(2, 200),
  body: longText(4000),
  visibility: z.enum(VISIBILITIES),
});

/** A branch names the idea it came from. */
export const createIdeaInput = ideaFields.extend({
  campaignId: id,
  parentIdeaId: id.nullable(),
});
export type CreateIdeaInput = z.infer<typeof createIdeaInput>;

export const updateIdeaInput = ideaFields.partial().extend({ ideaId: id, expectedVersion });
export type UpdateIdeaInput = z.infer<typeof updateIdeaInput>;

export const listIdeasInput = pageInput.extend({ campaignId: id });
export type ListIdeasInput = z.infer<typeof listIdeasInput>;

/** A decision is a record of what was chosen and why. It can't be edited afterwards. */
export const recordDecisionInput = z.object({
  campaignId: id,
  title: safeText(2, 200),
  rationale: longText(4000).min(1, "Say why this was decided"),
  visibility: z.enum(VISIBILITIES),
  ideaIds: linkedIds,
  taskIds: linkedIds,
});
export type RecordDecisionInput = z.infer<typeof recordDecisionInput>;

export const listDecisionsInput = pageInput.extend({ campaignId: id });
export type ListDecisionsInput = z.infer<typeof listDecisionsInput>;
